import React, { Component} from 'react';
import {ApolloClient, ApolloProvider, gql, InMemoryCache} from "@apollo/client";
import { useQuery } from '@apollo/client';
import { getBooksQuery } from '../queries/book-queries';
//import {graphql} from 'react-apollo'

const client = new ApolloClient({
    uri: 'http://localhost:5000/graphql',
    cache: new InMemoryCache()
})

function BookList(){
    //client.query({query:getBooksQuery}).then(result => console.log(result))
    return (
        <ApolloProvider client={client}>
            <div>
                <ul id="book-list">
                    {Books()}
                </  ul>
            </div>

        </ApolloProvider>
    )
}

function Books(){
    const {loading, error, data} = useQuery(getBooksQuery)
    if(loading) return <p>Loadling...</p>;
    if(error) return <p>Error :{error.stack}</p>;
    console.log(data)
    return (
        data.books.map(book => {
            return <li>{book.name}</li>
        })
    )
}

export default BookList;